import { render, staticRenderFns } from "./file-content-render.vue?vue&type=template&id=be01ba34&scoped=true&"
import script from "./file-content-render.vue?vue&type=script&lang=js&"
export * from "./file-content-render.vue?vue&type=script&lang=js&"
import style0 from "./file-content-render.vue?vue&type=style&index=0&id=be01ba34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be01ba34",
  null
  
)

export default component.exports